(function() {
    var PRODUCT_VIEW_FLAG = '__wrMixpanelProductViewTracked';
    var MIXPANEL_EVENT_PERSONALIZE = 'personalize_book_clicked';
    var MIXPANEL_EVENT_PRODUCT_VIEW = 'page_viewed_product';

    function isMixpanelReady() {
        return typeof window.mixpanel !== 'undefined' && typeof window.mixpanel.track === 'function';
    }

    function getViewportCategory() {
        var width = window.innerWidth || document.documentElement.clientWidth || 0;

        if (width < 768) return 'mobile';
        if (width < 1025) return 'tablet';
        return 'desktop';
    }

    function getBaseProperties() {
        var config = window.wrMixpanelConfig || {};
        var properties = {
            page_type: config.pageType || '',
            shopify_currency: config.shopifyCurrency || '',
            locale: config.locale || '',
            current_url: window.location.href,
            path: window.location.pathname,
            referrer: document.referrer || '',
            viewport_category: getViewportCategory()
        };

        if (config.themeName) {
            properties.theme_name = config.themeName;
        }

        return properties;
    }

    function registerDefaults() {
        if (!isMixpanelReady() || typeof window.mixpanel.register !== 'function') return;
        window.mixpanel.register(getBaseProperties());
    }

    function toNumber(value) {
        var numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }

    function cleanProperties(properties) {
        var cleaned = {};

        Object.keys(properties).forEach(function(key) {
            var value = properties[key];

            if (value === '' || value === null || typeof value === 'undefined') return;
            cleaned[key] = value;
        });

        return cleaned;
    }

    function buildProductProperties(source) {
        if (!source) return null;

        return cleanProperties(Object.assign({}, getBaseProperties(), {
            product_id: source.product_id || source.productId,
            product_handle: source.product_handle || source.productHandle,
            product_title: source.product_title || source.productTitle,
            variant_id: source.variant_id || source.variantId,
            variant_title: source.variant_title || source.variantTitle,
            product_type: source.product_type || source.productType,
            vendor: source.vendor,
            price: toNumber(source.price),
            currency: source.currency,
            language: source.language,
            book_number: source.book_number || source.bookNumber,
            char: source.char,
            char_gender: source.char_gender || source.charGender,
            char_character: source.char_character || source.charCharacter
        }));
    }

    function trackProductView() {
        if (!isMixpanelReady() || window[PRODUCT_VIEW_FLAG]) return;
        if (!document.body || !document.body.classList.contains('template-product')) return;

        var properties = buildProductProperties(window.__wrMixpanelProductContext);
        if (!properties || !properties.product_id) return;

        window.mixpanel.track(MIXPANEL_EVENT_PRODUCT_VIEW, properties);
        window[PRODUCT_VIEW_FLAG] = true;
    }

    function onReady(callback, attempts) {
        if (isMixpanelReady()) {
            callback();
            return;
        }

        if (attempts >= 40) return;

        window.setTimeout(function() {
            onReady(callback, attempts + 1);
        }, 250);
    }

    window.WRMixpanel = window.WRMixpanel || {};
    window.WRMixpanel.trackPersonalizeBookClick = function(button) {
        if (!isMixpanelReady() || !button) return;

        var properties = buildProductProperties({
            productId: button.dataset.productId,
            productHandle: button.dataset.productHandle,
            productTitle: button.dataset.productTitle,
            variantId: button.dataset.variantId,
            variantTitle: button.dataset.variantTitle,
            productType: button.dataset.productType,
            vendor: button.dataset.vendor,
            price: button.dataset.price,
            currency: button.dataset.currency,
            language: button.dataset.language,
            bookNumber: button.dataset.bookNumber,
            char: button.dataset.charParam,
            charGender: button.dataset.charGender,
            charCharacter: button.dataset.charCharacter
        });

        if (!properties || !properties.product_id) return;

        window.mixpanel.track(MIXPANEL_EVENT_PERSONALIZE, properties);
    };

    function initializeTracking() {
        registerDefaults();
        trackProductView();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            onReady(initializeTracking, 0);
        });
    } else {
        onReady(initializeTracking, 0);
    }
})();
